import { render, staticRenderFns } from "./UserAudit.vue?vue&type=template&id=232f1c68&"
import script from "./UserAudit.vue?vue&type=script&lang=js&"
export * from "./UserAudit.vue?vue&type=script&lang=js&"
import style0 from "./UserAudit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports